import React, { useState, useEffect, useRef } from "react";
import { SpinnerLoader } from "../../../utils/constants";
import ScrollToTop from "../../../ScrollToTop";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import AddBrandPopup from "../AddBrandPopup";
import {
  getSubCategorySpecificBrands,
  getGSTCategory,
  getAttribute,
  loadProductForEdit,
  getEstimateCost,
  sellAnItem,
  draftAnItem,
  updateProduct,
  addProduct,
  getCity,
} from "./../../../store/actions/sellItem";
import { useToasts } from "react-toast-notifications";
import { CKEditor } from "ckeditor4-react";
import Slider from "react-slick";
import Attributes from "./Attributes";
import Conditions from "./Conditions";
import { Error, customStyles } from "../index11";
import { RupeesIcon, priceWithSymbol } from "../../../utils/constants";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { isEmpty } from "../../../utils/commonFunctions";
import SuggestAddress from "./SuggestAddress";
import UploadImg from "./UploadImg";
import Popup from "../Popup";
import Toast from "light-toast";
import AccVerifiedPopup from "../AccVerifiedPopup";
import { parse } from "query-string";
import { uploadFile } from "react-s3";
import { Editor } from "@tinymce/tinymce-react";
import Loader from "../../Loader";
import { pl } from "date-fns/locale";
import { getCountry } from "../../../store/actions/sellerRegisterationAction";
import { StepContent } from "@material-ui/core";
import Multiselect from "multiselect-react-dropdown";
import moment from "moment";
import { getProductData } from "../../../store/actions/sellerRegisterationAction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { pack } from "html2canvas/dist/types/css/types/color";

const schema = yup.object().shape({
  title: yup
    .string()
    .required("Please enter product name")
    .min(2, "Product name must be at least 2 characters")
    .max(20, "Product name must be at most 20 characters"),
  product_quantity: yup.string().required("Please enter product quantity"),
  category: yup.string().required("Please select category"),
  subcategory: yup.string().required("Please select subcategory"),
  brand: yup.string().required("Please select brand"),
  hsn_code: yup.string().required("Please select HSN code"),
  gst: yup.string().required("Please select GST"),
  description: yup
    .string()
    .required("Please enter product description")
    .max(5009, "Description max length is 5000."),
  conditions: yup.string().required("Please select condition"),
  zip_code: yup
    .string()
    .required("Please enter pin code")
    .min(6, "Pin code must be 6 digit")
    .max(6, "Pin code must be 6 digit"),
  deliveryType: yup.string().required("Please select delievery type"),
  current_store_price: yup.string().required("Please enter product price"),
  addressSuggest: yup.string().required("Please select address"),
  shippingCost: yup
    .number()
    .integer("Please enter a whole number")
    .typeError("Please enter shipping cost")
    .required("Please enter shipping cost"),
});

const conditionOptions = [
  {
    head: "New",
    desc: "New with tags (NWT). Unopened packaging. Unused.",
    active: false,
  },
  {
    head: "Like new",
    desc: "New without tags (NWOT). No signs of wear. Unused.",
    active: false,
  },
  {
    head: "Good",
    desc: "Gently used. One / few minor flaws. Functional.",
    active: false,
  },
  {
    head: "Fair",
    desc: "Used, functional, multiple flaws / defects.",
    active: false,
  },
  {
    head: "Poor",
    desc: "Major flaws, may be damaged, for parts.",
    active: false,
  },
];

var settings = {
  dots: false,
  infinite: true,
  arrows: true,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 945,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const DeliveryOption = [
  { value: "Any", label: "Any" },
  { value: "Nationwide", label: "Nationwide" },
  { value: "Local", label: "Local" },
];

const S3_BUCKET = "inszn-ecom",
  REGION = "us-east-1",
  accessKeyId = "AKIARPELQCLSFEHBNS7K",
  secretAccessKey = "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";

const config = {
  bucketName: S3_BUCKET,
  region: REGION,
  accessKeyId,
  secretAccessKey,
};

const AddProduct = (props) => {
  let history = useHistory();
  let dispatch = useDispatch();
  let params = useParams();
  let location = useLocation();

  let categoriesList = useSelector(
    (store) => store.productListingInfo.categories
  );
  let brandList = useSelector((store) => store.sellItemInfo.specificBrands);
  let productDetail = useSelector(
    (store) => store.sellItemInfo.allDetailForEdit
  );
  let attributes = useSelector((store) => store.sellItemInfo.attributeList);
  let downlaod_app_banner = useSelector(
    (store) => store.cart.static_block_data
  );
  let userProfile = useSelector((store) => store.userProfile.userProfileBanner);
  let userAgent = navigator.userAgent;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
  } else {
    browserName = "No browser detection";
  }

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    getValues,
    setError,
    setValue,
    clearErrors,
  } = useForm({
    mode: "onSubmit",
    resolver: yupResolver(schema),
  });

  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [subcategories, setSubcategories] = useState([]);
  const [subChildcategories, setSubChildcategories] = useState([]);
  const [hsnNo, setHsnNo] = useState([]);
  const [gstList, setGstList] = useState([]);
  const [showbrandpopup, setShowbrandpopup] = useState(false);
  const [drogImg, setDrogImg] = useState([]);
  const [description, setDescription] = useState("");
  const [conditionList, setConditionList] = useState(conditionOptions);
  const [estimateCost, setEstimateCost] = useState({});
  const [descLength, setDescLength] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const { addToast } = useToasts();
  const [productList, setProductList] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [processList, setProcessList] = useState([]);
  const [processListLumps, setProcessListLumps] = useState([]);
  const [deliveryFirst, setDeliveryFirst] = useState([]);
  const [paymentTypeList, setPaymentTypeList] = useState([]);
  const [paymentType, setPaymentType] = useState("");
  const [paymentTypeError, setPaymentTypeError] = useState(false);

  const [productName, setProductName] = useState("");
  const [productNameError, setProductNameError] = useState(false);
  const [category, setCategory] = useState("");
  const [categoryError, setCategoryError] = useState(false);
  const [grade, setGrade] = useState("");
  const [gradeError, setGradeError] = useState("");
  const [process, setProcess] = useState("");
  const [processError, setProcessError] = useState("");
  const [weight, setWeight] = useState("");
  const [weightError, setWeightError] = useState(false);
  const [minOrderQty, setMinOrderQty] = useState("");
  const [minOrderErrror, setMinOrderErrror] = useState(false);
  const [minOrderHundredError, setMinOrderHundredError] = useState(false);
  const [proSize, setProdSize] = useState("");
  const [prodSizeError, setProdSizeError] = useState(false);
  const [sizeTol, setSizeTol] = useState("");
  const [sizeTolError, setSizeTolError] = useState(false);
  const [uploadImageData, setUploadImageData] = useState({});
  const [uploadImageDataError, setUploadImageDataError] = useState(false);
  const [productSpecification, setProductSpecification] = useState("");
  const [productSpecificationError, setProductSpecificationError] =
    useState(false);
  const [specificationTol, setSpecificationTol] = useState("");
  const [specificationTolError, setSpecificationTolError] = useState(false);
  const [deliveryFirstValue, setDeliveryFirstValue] = useState("");
  const [deliveryFirstValueError, setDeliveryFirstValueError] = useState(false);
  const [deliverySecondValue, setDeliverySecondValue] = useState("");
  const [deliverySecondValueError, setDeliverySecondValueError] =
    useState(false);
  const [cityValueError, setCityValueError] = useState(false);

  const [deliveryWinFirst, setDeliveryWinFirst] = useState("");
  const [deliveryWinFirstError, setDeliveryWinFirstError] = useState(false);
  const [deliveryWinSecond, setDeliveryWinSecond] = useState("");
  const [deliveryWinSecondError, setDeliveryWinSecondError] = useState(false);
  const [otherPayType, setOtherPayType] = useState("");
  const [otherPayTypeError, setOtherPayTypeError] = useState(false);
  const [price, setPrice] = useState("");
  const [priceError, setPriceError] = useState(false);
  const [productWeightNew, setProductWeightNew] = useState("");
  const [floorPrice, setFloorPrice] = useState("");
  const [floorPriceError, setFloorPriceError] = useState(false);
  const [loadingChanges, setLoadingChanges] = useState("");
  const [loadingChangesError, setLoadingChangesError] = useState(false);
  const [insuranceCharges, setInsuranceCharges] = useState("");
  const [insuranceChargesError, setInsuranceChargesError] = useState("");
  const [stateDataArr, setStateData] = useState({});
  const [city, setCity] = useState("");

  /////////////////// Specification //////////////////
  const [siOne, setSiOne] = useState("");
  const [siTwo, setSiTwo] = useState("");
  const [pOne, setPOne] = useState("");
  const [pTwo, setPTwo] = useState("");
  const [moOne, setMoOne] = useState("");
  const [moTwo, setMoTwo] = useState("");

  const [mnOne, setMnOne] = useState("");
  const [mnTwo, setMnTwo] = useState("");
  const [sOne, setSOne] = useState("");
  const [sTwo, setSTwo] = useState("");
  const [aiOne, setAiOne] = useState("");
  const [aiTwo, setAiTwo] = useState("");

  const [cOne, setCOne] = useState("");
  const [cTwo, setCTwo] = useState("");
  const [crOne, setCrOne] = useState("");
  const [crTwo, setCrTwo] = useState("");
  const [mgOne, setMgOne] = useState("");
  const [mgTwo, setMgTwo] = useState("");
  const [feOne, setFeOne] = useState("");
  const [feTwo, setFeTwo] = useState("");
  const [caOne, setCaOne] = useState("");
  const [caTwo, setCaTwo] = useState("");

  // New specs fields
  const [al2o3One, setAl2o3One] = useState("");
  const [al2o3Two, setAl2o3Two] = useState("");

  const [caoOne, setCaoOne] = useState("");
  const [caoTwo, setCaoTwo] = useState("");

  const [k2oOne, setK2oOne] = useState("");
  const [k2oTwo, setK2oTwo] = useState("");

  const [fcOne, setFcOne] = useState("");
  const [fcTwo, setFcTwo] = useState("");

  const [na2o3One, setNa2o3One] = useState("");
  const [na2o3Two, setNa2o3Two] = useState("");

  const [sio2One, setSio2One] = useState("");
  const [sio2Two, setSio2Two] = useState("");

  const [byDefaultImage, setByDefaultImage] = useState(
    "http://localhost:3000/assets/images/metal-2.jpg"
  );

  // Valid until

  const [validUntil, setValidUntil] = useState("");
  const [validUntilError, setValidUntilError] = useState(false);

  // Moisture
  const [moisture, setMoisture] = useState("");

  // Remarks

  const [remarks, setRemarks] = useState("");


  const [optionsSelect, setOptionsSelect] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [cityData, setCityData] = useState([]);

  const [optionsSelectRegionRegion, setOptionsSelectRegionRegion] = useState(
    []
  );
  const [selectedValueRegion, setSelectedValueRegion] = useState("");
  const [getCityList, setCityList] = useState([]);
  const [setRegion, setSetRegion] = useState([]);
  const [regionCity, setRegionsCity] = useState("");
  const [oldImages, setOldImages] = useState([]);
  const [packaging, setPackaging] = useState([]);
  const [packagingError, setPackageError] = useState(false);
  const [editPackaging, setEditPackaging] = useState([]);

  const [productData, setProductData] = useState([]);

  const [edit, setEdit] = useState([]);

  const [state, setState] = useState({
    categories: "",
    subcategory: "",
    brand: "",
    product_tag: {},
    subchildcategory: "",
    hsn_code: "",
    gst: "",
    description: "",
    deliveryType: "",
    isShippingFree: false,
    current_store_price: "",
    sell_price: "",
    latLang: {},
    attrData: [],
    isSubmited: false,
    isClickDraft: false,
    prodShippingDetail: {},
    prodImgs: [],
    addressName: "",
  });

  useEffect(() => {
    dispatch(
      getProductData({}, (status) => {
        setProductData(status);
      })
    );
  }, []);

  const setLangLat = (val, addressName) => {
    setValue("addressSuggest", val.lat);
    clearErrors("addressSuggest");
    setState({ ...state, latLang: val, addressName: addressName });
  };

  const onSelect = (e) => {
    setSelectedValue(e);
    let array = [];
    for (let a = 0; a < e.length; a++) {
      array.push(e[a].id);
    }
    setSetRegion(array);
    setDeliverySecondValueError(false);
    getRegion_listHandler(array);
  };

  const getRegion_listHandler = (array) => {
    let selectArray = [];
    for (let b = 0; b < array.length; b++) {
      const result = cityData.filter((word) => word._id == array[b]);
      selectArray.push(result.length > 0 ? result[0].cityData : []);
    }
    let getCityList = [];
    for (let c = 0; c < selectArray.length; c++) {
      let gtLength = selectArray[c].length;
      for (let d = 0; d < selectArray[c].length; d++) {
        getCityList.push(selectArray[c][d]);
      }
    }

    let formateList = [];
    for (let e = 0; e < getCityList.length; e++) {
      formateList.push({
        name: getCityList[e].cityName,
        id: getCityList[e]._id,
      });
    }
    setOptionsSelectRegionRegion(formateList);
    return formateList;
  };

  const onSelectRegion = (e) => {
    // let array = [];
    // for (let a = 0; a < e.length; a++) {
    //     array.push(e[a].id);
    // }
    setRegionsCity(e.target.value);
    setCityValueError(false);
  };

  const onRemove = (e) => {
    let array = [];
    for (let a = 0; a < e.length; a++) {
      array.push(e[a].id);
    }

    setSetRegion(array);
    getRegion_listHandler(array);
  };

  const onRemoveRegion = (e) => {
    setSelectedValue(e);
    let array = [];
    for (let a = 0; a < e.length; a++) {
      array.push(e[a].id);
    }
    setRegionsCity(array);
  };

  const setAttrData = (val) => {
    setState({ ...state, attrData: val });
  };

  const getCurrentDateTime = () => {
    return moment().format("YYYY-MM-DDTHH:mm");
  };

  useEffect(() => {
    const url = "http://localhost:3000/assets/images/metal-2.jpg";
    const fileName = url.substring(url.lastIndexOf("/") + 1);
    const arr = [];
    // fetch(url)
    //   .then((response) => response.blob())
    //   .then(
    //     (blob) =>
    //       new File([blob], `${fileName}`, {
    //         type: blob.type,
    //       })
    //   )
    //   .then((file) => {
    //     arr.push(file);
    //     if (params.id) {
    //     } else {
    //       setUploadImageData(arr);
    //     }
    //   });

    getCountry((callback) => {
      let newState = [...callback];
      setStateData(newState[0]);
    })(dispatch);
    let list = [
      { id: 1, name: "HC Silicomanganese" },
      { id: 2, name: "MC Silicomanganese" },
      { id: 3, name: "LC Silicomanganese" },
      { id: 4, name: "HC Ferromanganese" },
      { id: 5, name: "MC Ferromanganese" },
      { id: 6, name: "LC Ferromanganese" },
      { id: 7, name: "HC Ferro Chrome" },
      { id: 8, name: "MC Ferro Chrome" },
      { id: 9, name: "LC Ferro Chrome" },
      { id: 10, name: "LC Ferro Silicon" },
      { id: 11, name: "LC Ferromanganese Slag" },
      { id: 12, name: "Manganese Ore" },
    ];
    setProductList(list);

    let cList = [
      { id: "6304d4d848bf984c711e22b1", name: "lumps" },
      { id: "6304d69b48bf984c711e22d0", name: "chips" },
      { id: "6304d6ef48bf984c711e22ef", name: "fines" },
    ];

    let pList = [
      { id: 1, name: "jiggs" },
      { id: 2, name: "prime" },
    ];

    let pListLumps = [
      { id: 1, name: "Prime" },
      { id: 2, name: "Sized" },
    ];

    setProcessList(pList);
    setProcessListLumps(pListLumps);

    setProductCategory(cList);

    let dFList = [
      { id: 1, name: "FOR" },
      { id: 2, name: "EXW" },
      //   { id: 3, name: "Local" },
      //   { id: 4, name: "Nation Wide" },
      //   { id: 4, name: "Inside State Only" },
    ];

    setDeliveryFirst(dFList);

    let dSList = [
      { id: 1, name: "Noida" },
      { id: 2, name: "Muzaffarnagar" },
    ];

    // setDeliverySecond(dSList)

    let paymentList = [
      { id: 1, name: "Advance Payment" },
      { id: 2, name: "Next Day" },
      { id: 3, name: "7 Day Credit" },
      { id: 4, name: "Other" },
    ];

    setPaymentTypeList(paymentList);

    setShowLoader(true);
    setShowMessage("Please wait...");
    getGSTCategory((status) => setGstList(status));
    // getAttribute({ categoryId: "60826c013c535579f4bbe1b4", subcategoryId: "6087d0050f56cb4d6bdb65b1" })(dispatch);
    setTimeout(() => setShowLoader(false), 2000);
    if (params.id) {
      setTimeout(
        () =>
          loadProductForEdit(params.id, parse(location.search).type)(dispatch),
        40
      );
    }
    getCity((result) => {
      setCityData(result.data);
      if (result.status == "success") {
        let arr = [];
        for (let a = 0; a < result.data.length; a++) {
          arr.push({ name: result.data[a].name, id: result.data[a]._id });
        }
        setOptionsSelect(arr);
      }
    })(dispatch);
  }, []);

  useEffect(() => {
    let editVar = [];
    if (productDetail.packaging) {
      let prodPack = productDetail.packaging.map((item) => {
        editVar = [...editVar, item];
      });
    }
    if (params.id) {
      if (!isEmpty(productDetail)) {
        setProductName(productDetail.productName);
        setGrade(productDetail.productGrade);
        setProcess(productDetail.process);
        setWeight(productDetail.productWeight);
        setCategory(productDetail.category);
        setMinOrderQty(productDetail.minOrderQty);
        setProdSize(productDetail.productSize);
        setSizeTol(productDetail.productSizeTolerance);
        setSpecificationTol(productDetail.specificationTolerance);
        setDeliveryFirstValue(productDetail.deliveryType);
        setEditPackaging(editVar);
        setPackaging(editVar);

        ////////////// For REgions ///////////////

        let arr1 = [];
        for (let a = 0; a < productDetail.region.length; a++) {
          let getSelValReal =
            optionsSelect.length > 0
              ? optionsSelect.filter(
                  (word) => word.id === productDetail.region[a]
                )
              : [{ name: null, id: null }];
          arr1.push(getSelValReal[0]);
        }
        //  let formDataIdRegion = [];
        //  for(let y = 0; y < arr1.length; y++){
        //     formDataIdRegion.push(arr1[y].)
        //  }
        setSetRegion(productDetail.region);
        setSelectedValue(arr1);
        setDeliverySecondValue(arr1);

        ///////////// For City ///////////
        let REgionCity = getRegion_listHandler(productDetail.region);
        let arr2 = [];
        for (let a = 0; a < productDetail.city.length; a++) {
          let getSelValReal =
            REgionCity.length > 0
              ? REgionCity.filter((word) => word.id === productDetail.city[a])
              : [{ name: null, id: null }];
          arr2.push(getSelValReal[0]);
        }

        setRegionsCity(productDetail.city);
        setSelectedValueRegion(arr2);
        setDeliverySecondValue(arr2);

        let act = moment(productDetail.deliveryDateFrom).format("YYYY-MM-DD");
        let act2 = moment(productDetail.deliveryDateTo).format("YYYY-MM-DD");

        setDeliveryWinFirst(act);
        setDeliveryWinSecond(act2);
        setPaymentType(productDetail.paymentType);
        // setPackaging([]);
        setPrice(productDetail.productPrice.$numberDecimal);
        setFloorPrice(productDetail.floorPrice.$numberDecimal);
        if (productDetail.loadingCharge) {
          setLoadingChanges(productDetail.loadingCharge.$numberDecimal);
        }
        if (productDetail.insuranceCharge) {
          setInsuranceCharges(productDetail.insuranceCharge.$numberDecimal);
        }

        let originalIMages = [];
        for (let n = 0; n < productDetail.Image.length; n++) {
          originalIMages.push(productDetail.Image[n].original);
        }
        setOldImages(originalIMages);

        setState({
          prodImgs: productDetail.Image,
        });
        setOtherPayType(productDetail.otherPayType);

        const object = productDetail.spec;

        for (const property in object) {
          let value = object[property];
          let seprated = value.split("% ");
          let first = seprated[0];
          let second = seprated[1];

          if (property == "al") {
            setAiOne(first);
            setAiTwo(second);
          } else if (property == "c") {
            setCOne(first);
            setCTwo(second);
          } else if (property == "cr") {
            setCrOne(first);
            setCrTwo(second);
          } else if (property == "mg") {
            setMgOne(first);
            setMgTwo(second);
          } else if (property == "mn") {
            setMnOne(first);
            setMnTwo(second);
          } else if (property == "mo") {
            setMoOne(first);
            setMoTwo(second);
          } else if (property == "p") {
            setPOne(first);
            setPTwo(second);
          } else if (property == "s") {
            setSOne(first);
            setSTwo(second);
          } else if (property == "si") {
            setSiOne(first);
            setSiTwo(second);
          } else if (property == "fe") {
            setFeOne(first);
            setFeTwo(second);
          } else if (property == "ca") {
            setCaOne(first);
            setCaTwo(second);
          }
        }
      }
    } else {
      setProductName("");
      setGrade("");
      setProcess("");
      setWeight("");
      setCategory("");
      setMinOrderQty("");
      setProdSize("");
      setSizeTol("");
      setSpecificationTol("");
      setDeliveryFirstValue("");
      setEditPackaging([]);
      setPackaging([]);

      // ////////////// For REgions ///////////////

      // let arr1 = [];
      // for (let a = 0; a < productDetail.region.length; a++) {
      //     let getSelValReal = optionsSelect.length > 0 ?
      //         optionsSelect.filter(word => word.id === productDetail.region[a])
      //         : [{ name: null, id: null }];
      //     arr1.push(getSelValReal[0]);
      // }
      // //  let formDataIdRegion = [];
      // //  for(let y = 0; y < arr1.length; y++){
      // //     formDataIdRegion.push(arr1[y].)
      // //  }
      setSetRegion([]);
      setSelectedValue("");
      setDeliverySecondValue("");

      // ///////////// For City ///////////
      // let REgionCity = getRegion_listHandler(productDetail.region);
      // let arr2 = [];
      // for (let a = 0; a < productDetail.city.length; a++) {
      //     let getSelValReal = REgionCity.length > 0 ?
      //         REgionCity.filter(word => word.id === productDetail.city[a])
      //         : [{ name: null, id: null }];
      //     arr2.push(getSelValReal[0]);
      // }

      setRegionsCity("");
      setSelectedValueRegion("");
      setDeliverySecondValue("");

      // let act = moment(productDetail.deliveryDateFrom).format('YYYY-MM-DD');
      // let act2 = moment(productDetail.deliveryDateTo).format('YYYY-MM-DD');

      setDeliveryWinFirst("");
      setDeliveryWinSecond("");
      setPaymentType("");
      setPrice("");
      setFloorPrice("");
      setLoadingChanges("");
      setInsuranceCharges("");

      // let originalIMages = [];
      // for (let n = 0; n < productDetail.Image.length; n++) {
      //     originalIMages.push(productDetail.Image[n].original)
      // }
      setOldImages([]);

      // setState({
      //     prodImgs: productDetail.Image
      // })
      setOtherPayType("");

      // const object = productDetail.spec;

      // for (const property in object) {
      //     let value = object[property];
      //     let seprated = value.split("% ");
      //     let first = seprated[0];
      //     let second = seprated[1];

      setAiOne("");
      setAiTwo("");
      setCOne("");
      setCTwo("");
      setCrOne("");
      setCrTwo("");
      setMgOne("");
      setMgTwo("");
      setMnOne("");
      setMnTwo("");
      setMoOne("");
      setMoTwo("");
      setPOne("");
      setPTwo("");
      setSOne("");
      setSTwo("");
      setSiOne("");
      setSiTwo("");
      setFeOne("");
      setFeTwo("");
      setCaOne("");
      setCaTwo("");
      //     }
      // }
    }
  }, [productDetail, params]);

  useEffect(() => {
    if (!params.id) {
      setSubChildcategories([]);
      setSubcategories([]);
      setHsnNo([]);
      setEstimateCost({});
      setConditionList(conditionOptions);
      setState({
        ...state,
        categories: "",
        subcategory: "",
        brand: "",
        product_tag: {},
        subchildcategory: "",
        hsn_code: "",
        gst: "",
        description: "",
        deliveryType: "",
        isShippingFree: false,
        current_store_price: "",
        sell_price: "",
        latLang: {},
        attrData: [],
        isSubmited: false,
        isClickDraft: false,
        prodShippingDetail: {},
        prodImgs: [],
        addressName: "",
      });
      setValue("title", "");
      setValue("product_quantity", "");
      setValue("category", "");
      setValue("subcategory", "");
      setValue("brand", "");
      setValue("hsn_code", "");
      setValue("gst", "");
      setValue("description", "");

      setValue("conditions", "");
      setValue("zip_code", "");
      setValue("deliveryType", "");
      setValue("current_store_price", "");
      setValue("addressSuggest", "");
      setValue("shippingCost", "");
      setValue("sell_price", "");

      for (let index = 0; index < [1, 2, 3].length; index++) {
        let element = document.getElementById("tags_" + index);
        if (element) {
          element.value = "";
        }
      }
      // setTimeout(() => document.querySelector('.location-search-input').value = "", 1000)
    }
  }, [location]);

  const setSelectImgHandler = (val) => {};

  const closePopup = () => {
    props.history.push("/");
  };

  const handlerCategoryChange = (val) => {
    setState({
      ...state,
      categories: val,
      hsn_code: "",
      subcategory: "",
      brand: "",
      attrData: [],
    });
    setSubcategories(val.value.subcategoryData);
    getSubCategorySpecificBrands({ categoryId: val.value._id })(dispatch);
    setValue("category", val.value._id);
    clearErrors("category");
    setValue("subcategory", "");
    setValue("brand", "");
    setValue("hsn_code", "");
    setHsnNo([]);
    setSubChildcategories([]);
  };

  const handlerSubCategoryChange = (val) => {
    setSubChildcategories(val.value.subchildcategory);
    setState({ ...state, subcategory: val });
    let cateId = getValues("category");
    setHsnNo(val.value.hsnCode);
    getAttribute(
      { categoryId: cateId, subcategoryId: val.value._id },
      (callback) => {}
    )(dispatch);
    setValue("subcategory", val.value._id);
    clearErrors("subcategory");
  };

  const handlerOnChange = (val, name) => {
    if (name === "hsn_code") {
      setValue(name, val.value);
      clearErrors(name);
      setState({ ...state, [name]: val });
    } else if (name === "description") {
      if (val.length < 10000) {
        setState({ ...state, description: val });
        setValue("description", val);
        if (val === "") {
          setError(name);
        } else {
          clearErrors(name);
        }
        setDescLength(false);
      } else {
        // setDescLength(true)
      }
    } else if (name === "deliveryType") {
      setState({ ...state, [name]: val });
      setValue(name, val.value);
      clearErrors(name);
    } else {
      setState({ ...state, [name]: val });
      setValue(name, val.value._id);
      clearErrors(name);
    }
  };

  const inputOnchange = (e, name) => {
    if (name === "sell_price") {
      if (parseInt(e.target.value) <= parseInt(state.current_store_price)) {
        setState({ ...state, [name]: e.target.value });
        setValue(name, e.target.value);
        clearErrors(name);
      } else if (e.target.value === "") {
        setState({ ...state, [name]: e.target.value });
        setValue(name, e.target.value);
        clearErrors(name);
      }
    } else {
      setState({ ...state, [name]: e.target.value });
      setValue(name, e.target.value);
      clearErrors(name);
    }

    let cateId = getValues("category");
    if (name === "sell_price") {
      if (e.target.value !== "") {
        getEstimateCost(
          { categoryId: cateId, price: e.target.value },
          (callback) => {
            setEstimateCost(callback);
          }
        );
      } else {
        getEstimateCost(
          { categoryId: cateId, price: state.current_store_price },
          (callback) => {
            setEstimateCost(callback);
          }
        );
      }
    } else {
      getEstimateCost(
        { categoryId: cateId, price: e.target.value },
        (callback) => {
          setEstimateCost(callback);
        }
      );
    }
  };

  const conditionChange = (val) => {
    let newconditionList = [...conditionList];
    newconditionList = newconditionList.map((item) => {
      if (item.head === val.head) {
        return { ...item, active: true };
      } else {
        return { ...item, active: false };
      }
    });
    setConditionList(newconditionList);
    clearErrors("conditions");
    setValue("conditions", newconditionList[0].head);
  };

  const product_tag = (e, index) => {
    const product_tag = { ...state.product_tag };
    product_tag[index] = e.target.value;
    setState({ ...state, product_tag });
  };

  function getPromise(prodImgs) {
    return new Promise(async (resolve, reject) => {
      uploadFile(prodImgs, config)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          resolve(err);
        });
    });
  }

  function resolveThisFirst() {
    let newArr = [];
    for (let i = 0; i < state.prodImgs.length; i++) {
      //find is file or not
      if (state.prodImgs[i].type) {
        newArr.push(getPromise(state.prodImgs[i]));
      }
    }

    return Promise.all(newArr);
  }

  if(userProfile && userProfile.userdata && userProfile.userdata.create_listing_access == false){
    window.location.href = "/";
  }


  const onSubmit = async (data) => {
    let isError = false;

    attributes.forEach((item, i) => {
      if (item.catlog_input_type === "text") {
        let ele = document.getElementById(`attinput_${i}`);
        let eleErr = document.getElementById(`attinputError_${i}`);
        if (ele.value === "") {
          isError = true;
          window.scrollTo(0, 2000);
          eleErr.style.display = "block";
        }
      }
    });

    state.attrData.forEach((item, i) => {
      if (item.catlog_input_type !== "text") {
        let ele = document.getElementById(`fixed-attr_${i}`);
        if (item.required) {
          isError = true;
          window.scrollTo(0, 2000);
          ele.style.display = "block";
        }
      }
    });

    let productDescAttr = [];

    for (let item in state.prodShippingDetail) {
      let val = state.prodShippingDetail[item].value;
      if (state.prodShippingDetail[item].type === "inche") {
        val = Math.round(state.prodShippingDetail[item].value / 0.3937);
      } else if (state.prodShippingDetail[item].type === "feet") {
        val = Math.round(state.prodShippingDetail[item].value / 0.032808);
      } else if (state.prodShippingDetail[item].type === "meter") {
        val = Math.round(state.prodShippingDetail[item].value / 0.01);
      } else if (state.prodShippingDetail[item].type === "kg") {
        val = Math.round(state.prodShippingDetail[item].value * 1000);
      }
      productDescAttr.push({ name: item, value: val });
    }

    let selectedCondition = conditionList.filter((item) => item.active);
    let selectedAttr = state.attrData.filter((item) => item.isSelected);

    let setAtt = selectedAttr.map((item) => {
      let selectedVal = item.default_value.filter(
        (newItem) => newItem.isSelected
      );
      return {
        name: item.attribute_label[0],
        value: selectedVal[0].store_view[0].name,
        att_id: item._id,
      };
    });

    let prodTag = [];

    for (let item in state.product_tag) {
      prodTag.push(state.product_tag[item]);
    }

    let payload = {
      title: data.title,
      product_description: data.description,
      product_quantity: data.product_quantity,
      is_auction: "No",
      category: data.category,
      subcategory: data.subcategory,
      subchildcategory: "",
      brand: data.brand,
      hsn_code: data.hsn_code,
      gst: data.gst,
      draftId: null,
      current_store_price: data.current_store_price,
      sell_price: data.sell_price,
      zip_code: data.zip_code,
      delievery_type: data.deliveryType,
      shippingCost: state.isShippingFree ? 0 : data.shippingCost,
      lat: state.latLang.lat,
      long: state.latLang.long,
      isShippingFree: state.isShippingFree,
      condition: selectedCondition[0].head,
      product_tag: prodTag.join(", "),
      Attrs: [...setAtt, ...productDescAttr],
      warehouseAddress: state.addressName,
    };

    if (!isError && !descLength) {
      setShowLoader(true);
      setShowMessage("Please wait...");
      resolveThisFirst()
        .then((data) => {
          let newImgState = [...state.prodImgs];
          newImgState = newImgState.filter((item) => !item.type);
          let newImgs = [...newImgState, ...data];
          payload.imageData = newImgs.map((item) => ({
            original: item.location ? item.location : item.original,
          }));
          payload.default_image_name = newImgs[0].location;

          // return

          let productId = params.id;
          if (productId) {
            payload.productId = productId;
            updateProduct(payload, productId, (status) => {
              if (status) {
                setShowLoader(false);
                setState({ ...state, isSubmited: true });
              } else {
                setShowLoader(false);
                addToast("Failed to submit", {
                  appearance: "error",
                  autoDismissTimeout: 2500,
                });
              }
            })(dispatch);
          } else {
            sellAnItem(payload, (status) => {
              if (status) {
                setShowLoader(false);
                setState({ ...state, isSubmited: true });
              } else {
                setShowLoader(false);
                addToast("Failed to submit", {
                  appearance: "error",
                  autoDismissTimeout: 2500,
                });
              }
            })(dispatch);
          }
        })
        .catch((err) => {});
    }
  };

  const draftItem = () => {
    let productDescAttr = [];

    for (let item in state.prodShippingDetail) {
      let val = state.prodShippingDetail[item].value;
      if (state.prodShippingDetail[item].type === "inche") {
        val = Math.round(state.prodShippingDetail[item].value / 0.3937);
      } else if (state.prodShippingDetail[item].type === "feet") {
        val = Math.round(state.prodShippingDetail[item].value / 0.032808);
      } else if (state.prodShippingDetail[item].type === "meter") {
        val = Math.round(state.prodShippingDetail[item].value / 0.01);
      } else if (state.prodShippingDetail[item].type === "kg") {
        val = Math.round(state.prodShippingDetail[item].value * 1000);
      }
      productDescAttr.push({ name: item, value: val });
    }

    let selectedCondition = conditionList.filter((item) => item.active);
    let selectedAttr = state.attrData.filter((item) => item.isSelected);

    let setAtt = selectedAttr.map((item) => {
      let selectedVal = item.default_value.filter(
        (newItem) => newItem.isSelected
      );
      return {
        name: item.attribute_label[0],
        value: selectedVal[0].store_view[0].name,
        att_id: item._id,
      };
    });

    let prodTag = [];

    for (let item in state.product_tag) {
      prodTag.push(state.product_tag[item]);
    }

    let payload = {
      title: getValues("title"),
      product_description: getValues("description") || "",
      product_quantity: getValues("product_quantity"),
      is_auction: "No",
      category: getValues("category") || "",
      subcategory: getValues("subcategory") || "",
      subchildcategory: getValues("subcategory") || "",
      brand: getValues("brand") || "",
      hsn_code: getValues("hsn_code") || "",
      gst: getValues("gst") || "",
      draftId: null,
      current_store_price: getValues("current_store_price") || "",
      sell_price: getValues("sell_price") || "",
      zip_code: getValues("zip_code") || "",
      delievery_type: getValues("deliveryType") || "",
      shippingCost: getValues("shippingCost") || "",
      lat: state.latLang.lat,
      long: state.latLang.long,
      isShippingFree: state.isShippingFree,
      condition: selectedCondition[0] ? selectedCondition[0].head : "",
      product_tag: prodTag.join(", "),
      Attrs: [...setAtt, ...productDescAttr],
      warehouseAddress: state.addressName,
    };

    setShowLoader(true);
    setShowMessage("Please wait...");
    resolveThisFirst()
      .then((data) => {
        let newImgState = [...state.prodImgs];

        newImgState = newImgState.filter((item) => !item.type);
        let newImgs = [...newImgState, ...data];
        payload.imageData = newImgs.map((item) => ({
          original: item.location ? item.location : item.original,
        }));
        payload.default_image_name =
          newImgs.length > 0 ? newImgs[0].location : "";

        // return

        draftAnItem(payload, (status) => {
          if (status) {
            setShowLoader(false);
            setState({ ...state, isClickDraft: true });
          } else {
            setShowLoader(false);
          }
        });
      })
      .catch((err) => {});
  };

  const unitHandler = (e, name, type) => {
    let newState = { ...state.prodShippingDetail };
    if (type === "input") {
      let eleErr = document.getElementById(
        `attinputError_${e.target.id.split("_")[1]}`
      );
      eleErr.style.display = "none";
      newState[name] = { ...newState[name], value: e.target.value };
    } else {
      newState[name] = { ...newState[name], type: e.target.value };
    }
    setState({ ...state, prodShippingDetail: newState });
  };

  const setProdImgs = (val) => {
    let binaryData = [];
    let originalIMages = [];
    for (let x = 0; x < val.length; x++) {
      if ("original" in val[x]) {
        originalIMages.push(val[x].original);
        setOldImages(originalIMages);
      } else {
        binaryData.push(val[x]);
      }
    }
    setUploadImageData(binaryData);

    setUploadImageDataError(false);
    setState({ ...state, prodImgs: val });
  };

  ///////////////////////////////////////////////////////// New Form /////////////////////////////////////////////////////
  const productNameHandler = (e) => {
    setProductName(e.target.value);
    if(e.target.value === 'Pig Iron') {
      setCategory('675fe55b32e6d8ecfb6c256f')
      setProcess('Pig Iron')
      setSizeTol('0')
      setSpecificationTol('0')
    }
    setProductNameError(false);
  };

  const productCategoryHandler = (e) => {
    setCategory(e.target.value);
    setCategoryError(false);
  };

  const gradeHandle = (e) => {    
    setGrade(e.target.value);
    setGradeError(false);
  };

  const processHandler = (e) => {
    if (e.target.value) {
      setProcess(e.target.value);
    }
    setProcessError(false);
  };
  const deliveryFirstHandler = (e) => {
    setDeliveryFirstValue(e.target.value);
    setDeliveryFirstValueError(false);
  };

  const paymentTypeHandler = (e) => {
    setPaymentType(e.target.value);
    setPaymentTypeError(false);
  };
  const weightHandle = (e) => {
    var regex = /^[0-9-+()]*$/;
    if (regex.test(e.target.value)) {
      setWeight(e.target.value);
      setWeightError(false);
    }
  };
  const minOrderHandle = (e) => {
    var regex = /^[0-9-+()]*$/;
    if (regex.test(e.target.value)) {
      setMinOrderQty(e.target.value);
      setMinOrderErrror(false);
      setMinOrderHundredError(false);
    }
  };
  const prodSizeHandle = (e) => {       
    setProdSize(e.target.value);      
  };
  const sizeTolHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (regex.test(e.target.value) && e.target.value <= 100) {
      setSizeTol(e.target.value);
      setSizeTolError(false);
    }
  };

  const specTolHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (regex.test(e.target.value) && e.target.value <= 100) {
      setSpecificationTol(e.target.value);
      setSpecificationTolError(false);
    }
  };

  const moistureHandle = (e) => {
    setMoisture(e.target.value);
  };

  const deliveryWinFirstHandle = (e) => {
    setDeliveryWinFirst(e.target.value);
    setDeliveryWinFirstError(false);
  };
  const deliveryWinSEcondHandle = (e) => {
    setDeliveryWinSecond(e.target.value);
    setDeliveryWinSecondError(false);
  };

  const validUntilHandle = (e) => {
    setValidUntil(e.target.value);
    setValidUntilError(false);
  };

  const otherPayTypeHandle = (e) => {
    setOtherPayType(e.target.value);
    setOtherPayTypeError(false);
  };
  const priceHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (regex.test(e.target.value)) {
      setPrice(e.target.value);
      setPriceError(false);
    }
  };
  const productWeightNewHandle = (e) => {    
      setProductWeightNew(e.target.value);
  };
  const floorPriceHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (regex.test(e.target.value)) {
      setFloorPrice(e.target.value);
      setFloorPriceError(false);
    }
  };
  const loadingChangesHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (regex.test(e.target.value)) {
      setLoadingChanges(e.target.value);
      setLoadingChangesError(false);
    }
  };
  const insuranceChargesHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (regex.test(e.target.value)) {
      setInsuranceCharges(e.target.value);
      setInsuranceChargesError(false);
    }
  };

  const siOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      siTwo == "N/A"
    ) {
      setSiOne(e.target.value);
      setProductSpecificationError(false);
    }
  };
  const siTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setSiTwo(e.target.value);
  };
  const pOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      pTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setPOne(e.target.value);
    }
  };
  const pTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setPTwo(e.target.value);
  };
  const moOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      moTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setMoOne(e.target.value);
    }
  };
  const moTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setMoTwo(e.target.value);
  };
  const mnOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      mnTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setMnOne(e.target.value);
    }
  };
  const mnTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setMnTwo(e.target.value);
  };
  const sOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      sTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setSOne(e.target.value);
    }
  };
  const sTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setSTwo(e.target.value);
  };
  const aiOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      aiTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setAiOne(e.target.value);
    }
  };
  const aiTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setAiTwo(e.target.value);
  };
  const cOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      cTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setCOne(e.target.value);
    }
  };
  const cTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setCTwo(e.target.value);
  };
  const crOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      crTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setCrOne(e.target.value);
    }
  };
  const crTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setCrTwo(e.target.value);
  };
  const mgOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      mgTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setMgOne(e.target.value);
    }
  };

  const mgTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setMgTwo(e.target.value);
  };

  const feOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      feTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setFeOne(e.target.value);
    }
  };

  const feTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setFeTwo(e.target.value);
  };

  const caOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      caTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setCaOne(e.target.value);
    }
  };

  const caTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setCaTwo(e.target.value);
  };

  const al2o3OneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      al2o3Two == "N/A"
    ) {
      setProductSpecificationError(false);
      setAl2o3One(e.target.value);
    }
  };

  const al2o3TwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setAl2o3Two(e.target.value);
  };

  const caoOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      caoTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setCaoOne(e.target.value);
    }
  };

  const caoTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setCaoTwo(e.target.value);
  };

  const k2oOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      k2oTwo == "N/A"
    ) {
      setProductSpecificationError(false);
      setK2oOne(e.target.value);
    }
  };

  const k2oTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setK2oTwo(e.target.value);
  };

  const fcOneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      fcOne == "N/A"
    ) {
      setProductSpecificationError(false);
      setFcOne(e.target.value);
    }
  };

  const fcTwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setFcTwo(e.target.value);
  };

  const na2o3OneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      na2o3Two == "N/A"
    ) {
      setProductSpecificationError(false);
      setNa2o3One(e.target.value);
    }
  };

  const na2o3TwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setNa2o3Two(e.target.value);
  };

  const sio2OneHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    if (
      (regex.test(e.target.value) && e.target.value <= 100) ||
      sio2Two == "N/A"
    ) {
      setProductSpecificationError(false);
      setSio2One(e.target.value);
    }
  };

  const sio2TwoHandle = (e) => {
    var regex = /^[0-9-+()/\W|_/g]*$/;
    setProductSpecificationError(false);
    setSio2Two(e.target.value);
  };

  const handlePackaging = (e) => {
    setPackaging(e.target.value);
  };

  const handleJute = (e) => {
    if (e.target.checked) {
      let data = [...packaging, e.target.value];
      setPackaging(data);
      setPackageError(false);
    } else {
      let filteredData = packaging.filter((item) => item !== e.target.value);
      setPackaging(filteredData);
    }
  };

  const handleJute50 = (e) => {
    if (e.target.checked) {
      let data = [...packaging, e.target.value];
      setPackaging(data);
      setPackageError(false);
    } else {
      let filteredData = packaging.filter((item) => item !== e.target.value);
      setPackaging(filteredData);
    }
  };

  const handleJumbo = (e) => {
    if (e.target.checked) {
      let data = [...packaging, e.target.value];
      setPackaging(data);
      setPackageError(false);
    } else {
      let filteredData = packaging.filter((item) => item !== e.target.value);
      setPackaging(filteredData);
    }
  };

  const deliveryWinThirdHandle = (e) => {
    setCity(e.target.value);
  };
  function isValid() {
    let payloadProdImgs = [];
    state.prodImgs.forEach((item) => {
      if (item._id) {
        payloadProdImgs = [...payloadProdImgs, item];
      }
    });
    if (productName == "") {
      setProductNameError(true);
      document.getElementById("productName").focus();
    } else if (category == "") {
      setCategoryError(true);
      document.getElementById("category").focus();
    } else if ((category == "6304d69b48bf984c711e22d0" || category == "6304d6ef48bf984c711e22ef" || category == "6304d4d848bf984c711e22b1") && process == "") {
      setProcessError(true);
      document.getElementById("jiggs").focus();
    } else if (grade == "") {
      setGradeError(true);
      document.getElementById("grade").focus();
    }
    // else if (weight == "") {
    //   setWeightError(true);
    //   document.getElementById("productWeight").focus();
    // }
    // else if (minOrderQty == "") {
    //   setMinOrderErrror(true);
    //   document.getElementById("minOrder").focus();
    // }
    else if (minOrderQty > 100) {
      setMinOrderHundredError(true);
      document.getElementById("minOrder").focus();
    } else if (sizeTol == "") {
      setSizeTolError(true);
      document.getElementById("sizeTolerance").focus();
    } else if (
      Object.keys(uploadImageData).length <= 0 &&
      payloadProdImgs.length == 0
    ) {
      setUploadImageDataError(true);
    } else if (
      siTwo == "" &&
      pTwo == "" &&
      moTwo == "" &&
      mnTwo == "" &&
      sTwo == "" &&
      aiTwo == "" &&
      cTwo == "" &&
      crTwo == "" &&
      mgTwo == "" &&
      feTwo == "" &&
      caTwo == ""
    ) {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    } else if ((siTwo !== "" && siOne == "") && siTwo !== "N/A") {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    } else if ((pTwo !== "" && pOne == "") && pTwo !== "N/A") {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    } else if ((moTwo !== "" && moOne == "") && moTwo !== "N/A") {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    } else if ((mnTwo !== "" && mnOne == "") && mnTwo !== "N/A") {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    } else if ((sTwo !== "" && sOne == "") && sTwo !== "N/A") {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    } else if ((aiTwo !== "" && aiOne == "") && aiTwo !== "N/A") {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    } else if ((cTwo !== "" && cOne == "") && cTwo !== "N/A") {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    } else if ((crTwo !== "" && crOne == "") && crTwo !== "N/A") {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    } else if ((mgTwo !== "" && mgOne == "") && mgTwo !== "N/A") {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    } else if ((feTwo !== "" && feOne == "") && feTwo !== "N/A") {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    } else if ((caTwo !== "" && caOne == "") && caTwo !== "N/A") {
      setProductSpecificationError(true);
      document.getElementById("specTol").focus();
    }
    // } else if (
    //   siOne == "" &&
    //   pOne == "" &&
    //   moOne == "" &&
    //   mnOne == "" &&
    //   sOne == "" &&
    //   aiOne == "" &&
    //   cOne == "" &&
    //   crOne == "" &&
    //   mgOne == "" &&
    //   feOne == "" &&
    //   caOne == ""
    // ) {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    // } else if (siOne !== "" && siTwo == "") {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    // } else if (pOne !== "" && pTwo == "") {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    // } else if (moOne !== "" && moTwo == "") {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    // } else if (mnOne !== "" && mnTwo == "") {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    // } else if (sOne !== "" && sTwo == "") {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    // } else if (aiOne !== "" && aiTwo == "") {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    // } else if (cOne !== "" && cTwo == "") {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    // } else if (crOne !== "" && crTwo == "") {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    // } else if (mgOne !== "" && mgTwo == "") {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    // } else if (feOne !== "" && feTwo == "") {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    // } else if (caOne !== "" && caTwo == "") {
    //   setProductSpecificationError(true);
    //   document.getElementById("specTol").focus();
    //}
     else if (specificationTol == "") {
      setSpecificationTolError(true);
      document.getElementById("specTol").focus();
    } else if (deliveryFirstValue == "") {
      setDeliveryFirstValueError(true);
      document.getElementById("deliveryType").focus();
    } else if (setRegion.length == 0) {
      setDeliverySecondValueError(true);
      document.getElementById("deliveryType").focus();
    } else if (regionCity == "") {
      setCityValueError(true);
      document.getElementById("deliveryType").focus();
    }
    // else if (deliveryWinFirst == "") {
    //   setDeliveryWinFirstError(true);
    //   document.getElementById("startDate").focus();
    // }
    // else if (deliveryWinSecond == "") {
    //   setDeliveryWinSecondError(true);
    //   document.getElementById("endDate").focus();
    // }
    else if (paymentType == "") {
      setPaymentTypeError(true);
      document.getElementById("paymentType").focus();
    } else if (packaging.length == 0) {
      setPackageError(true);
      document.getElementById("paymentType").focus();
    } else if (paymentType == "Other" && otherPayType == "") {
      setOtherPayTypeError(true);
      document.getElementById("otherPayment").focus();
    }
    // else if (price == "") {
    //   setPriceError(true);
    //   document.getElementById("price").focus();
    // }
    // else if (floorPrice == "") {
    //   setFloorPriceError(true);
    //   document.getElementById("floorPrice").focus();
    // } 
    // } 
    
    // }
    
    else {
      return true;
    }
  }
  const submitHandle = (e) => {
    let payloadProdImgs = [];
    state.prodImgs.forEach((item) => {
      if (item._id) {
        payloadProdImgs = [...payloadProdImgs, item];
      }
    });
    e.preventDefault();
    if (isValid()) {
      setShowLoader(true);
      setShowMessage("Please wait...");
      const payload = {
        productName: productName,
        productGrade: grade,
        process: process,
        productWeight: weight,
        category: category,
        minOrderQty: minOrderQty,
        productSize: proSize,
        productSizeTolerance: sizeTol,
        specificationTolerance: specificationTol,
        deliveryType: deliveryFirstValue,
        exwCity: deliverySecondValue,
        deliveryDateFrom: deliveryWinFirst,
        deliveryDateTo: deliveryWinSecond,
        paymentType: paymentType,
        productPrice: price,
        productWeightNew: productWeightNew,
        floorPrice: floorPrice,
        loadingCharge:
          loadingChanges && loadingChanges.length ? loadingChanges : 0,
        insuranceCharge:
          insuranceCharges && insuranceCharges.length ? insuranceCharges : 0,
        otherPayType: otherPayType,
        packaging: packaging,
        si: siOne ? siOne + "% " + siTwo : "N/A",
        p: pOne ? pOne + "% " + pTwo : "N/A",
        mo: moOne ? moOne + "% " + moTwo : "N/A",
        mn: mnOne ? mnOne + "% " + mnTwo : "N/A",
        s: sOne ? sOne + "% " + sTwo : "N/A",
        al: aiOne ? aiOne + "% " + aiTwo : "N/A",
        c: cOne ? cOne + "% " + cTwo : "N/A",
        cr: crOne ? crOne + "% " + crTwo : "N/A",
        mg: mgOne ? mgOne + "% " + mgTwo : "N/A",
        fe: feOne ? feOne + "% " + feTwo : "N/A",
        ca: caOne ? caOne + "% " + caTwo : "N/A",
        al2o3: al2o3One ? al2o3One + "% " + al2o3Two : "N/A",
        cao: caoOne ? caoOne + "% " + caoTwo : "N/A",
        k2o: k2oOne ? k2oOne + "% " + k2oTwo : "N/A",
        na2o3: na2o3One ? na2o3One + "% " + na2o3Two : "N/A",
        sio2: sio2One ? sio2One + "% " + sio2Two : "N/A",
        fc: fcOne ? fcOne + "% " + fcTwo : "N/A",
        region: setRegion,
        city: regionCity,
        oldImages: JSON.stringify(payloadProdImgs),
        remarks,
        expiryDate: validUntil,
        moisture: moisture,
        // imageData:uploadImageData
      };
      // return;
      let formdata = new FormData();
      for (let item in payload) {
        formdata.append(item, payload[item]);
      }

      for (let item in uploadImageData) {
        formdata.append("imageData", uploadImageData[item]);
      }

      if (params.id) {
        formdata.append("productId", params.id);
        // formdata.append("oldImages", JSON.stringify(state.prodImgs));

        updateProduct(formdata, params.id, (status) => {
          if (status) {
            setShowLoader(false);
            setState({ ...state, isSubmited: true });
          } else {
            setShowLoader(false);
            addToast("Failed to submit", {
              appearance: "error",
              autoDismissTimeout: 2500,
            });
          }
        })(dispatch);
      } else {
        addProduct(formdata, (status) => {
          if (status.status == "success") {
            setShowLoader(false);
            addToast(status.message, {
              appearance: "success",
              autoDismissTimeout: 2500,
            });
            setTimeout(() => {
              props.history.push("/");
            }, 1000);
          } else {
            setShowLoader(false);
            addToast(status.message, {
              appearance: "error",
              autoDismissTimeout: 2500,
            });
          }
        })(dispatch);
      }
    }
  };

  const redirectPage = () => {
    window.location = "/profile/my-listing/active";
  };

  return (
    <div className="sell-item sell-item-content sell-product-wrapper seller-add-product">
      {showLoader ? <Loader message={showMessage} /> : null}
      {state.isSubmited && (
        <Popup
          // closePopup={closePopup}
          submitFun={redirectPage}
          content={
            params.id
              ? "Your product has been updated successfully"
              : "Your product has been uploaded successfully"
          }
          successTxt={"Go to listing page"}
          type={"submit"}
        />
      )}
      {state.isClickDraft && (
        <Popup
          // closePopup={closePopup}
          submitFun={() => history.push("/profile/my-listing/draft")}
          content={"Your product has been Saved."}
          successTxt={"Go to Draft page"}
          type={"submit"}
        />
      )}
      <div className={spinnerLoader ? "spinner-time-div" : ""}>
        {!isEmpty(userProfile) &&
        userProfile.userdata &&
        userProfile.userdata.userType === "Seller" ? (
          <form onSubmit={(e) => submitHandle(e)}>
            <div className="sell-image"></div>
            <div className="menu-item-container">
              <div className="navigation-screen edit-product-screen">
                <div className="add-product-wrapper">
                  <ScrollToTop />
                  {showbrandpopup && (
                    <AddBrandPopup
                      closePopup={setShowbrandpopup}
                      setShowbrandpopup={setShowbrandpopup}
                    />
                  )}
                  <h5> TELL US WHAT YOU ARE SELLING?</h5>
                  <div className="product-form">
                    <div className="slct-optns select-wrapper">
                      <div className="form-block-wrap">
                        <div className="enter-mobile-label">
                          Product Name <span className="highlighted">*</span>
                        </div>
                        <div className="select-main-wrapper">
                          <select
                            onChange={(e) => productNameHandler(e)}
                            id="productName"
                          >
                            <option value={""}>Select</option>
                            {productData.map((item) => (
                              <option
                                value={item.name}
                                selected={
                                  productName == item.name ? true : false
                                }
                              >
                                {item.name}
                              </option>
                            ))}
                          </select>
                          <i className="icon-arrow-down"></i>
                        </div>
                        {productNameError ? (
                          <span className="error">
                            Please select product name
                          </span>
                        ) : null}
                      </div>
                      {productName !== 'Pig Iron' ? <div className="form-block-wrap">
                        <div className="enter-mobile-label">
                          Product Category{" "}
                          <span className="highlighted">*</span>
                        </div>
                        <div className="select-main-wrapper">
                          <select
                            onChange={(e) => productCategoryHandler(e)}
                            id="category"
                            disabled={productName === 'Pig Iron'}
                            style={{ cursor: productName === 'Pig Iron' ? 'not-allowed' : 'default' }}
                          >
                            <option disabled={true} selected={true}>
                              Select
                            </option>
                            {productCategory.map((item) => (
                              <option
                                value={item.id}
                                selected={category == item.id ? true : null}
                              >
                                {item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()}
                              </option>
                            ))}
                          </select>
                          <i className="icon-arrow-down"></i>
                        </div>
                        {categoryError ? (
                          <span className="error">
                            Please select product category
                          </span>
                        ) : null}
                      </div>: ' '}
                      
                    </div>
                    <div className="dynamic-select-wrap">
                      {category == "6304d69b48bf984c711e22d0" ||
                      category == "6304d6ef48bf984c711e22ef" ? (
                        <div className="form-block-wrap">
                          {/* <div className="enter-mobile-label">Process <span className="highlighted">*</span></div> */}
                          <div className="select-main-wrapper">
                            <select
                              onChange={(e) => processHandler(e)}
                              id="jiggs"
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              {processList.map((item) => (
                                <option
                                  value={item._id}
                                  selected={process == item.name ? true : false}
                                >
                                  {item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()}
                                </option>
                              ))}
                            </select>
                            <i className="icon-arrow-down"></i>
                          </div>
                          {processError ? (
                            <span className="error">
                              Please select Jiggs or Prime
                            </span>
                          ) : null}
                        </div>
                      ) : null}
                    </div>

                    <div className="dynamic-select-wrap">
                      {category == "6304d4d848bf984c711e22b1" ? (
                        <div className="form-block-wrap">
                          {/* <div className="enter-mobile-label">Process <span className="highlighted">*</span></div> */}
                          <div className="select-main-wrapper">
                            <select
                              onChange={(e) => processHandler(e)}
                              id="jiggs"
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              {processListLumps.map((item) => (
                                <option
                                  value={item._id}
                                  selected={process == item.name ? true : false}
                                >
                                  {item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()}
                                </option>
                              ))}
                            </select>
                            <i className="icon-arrow-down"></i>
                          </div>
                          {processError ? (
                            <span className="error">
                              Please select Prime or sized
                            </span>
                          ) : null}
                        </div>
                      ) : null}
                    </div>

                    <div className="slct-optns select-wrapper">
                      <div className="form-block-wrap">
                        <label className="enter-mobile-label">
                          Product Grade<span className="highlighted">*</span>
                        </label>
                        <div className="input-wrap">
                          <input
                            className={"input-url"}
                            type="text"
                            name="product_tag"
                            placeholder="e.g. 60/14, 30-60"
                            onChange={(e) => gradeHandle(e)}
                            maxLength={25}
                            id="grade"
                            value={grade}
                          />
                        </div>
                        {gradeError ? (
                          <span className="error">
                            Please enter product grade
                          </span>
                        ) : null}
                      </div>
                      <div className="form-block-wrap">
                        <label className="enter-mobile-label">
                          Available Qty (mt){" "}
                          {/* <span className="highlighted">*</span> */}
                        </label>
                        <div className="input-wrap">
                          <input
                            className={"input-url"}
                            type="text"
                            name="product_tag"
                            placeholder="e.g. 200 MT"
                            onChange={(e) => weightHandle(e)}
                            maxLength={25}
                            id="productWeight"
                            value={weight}
                          />
                        </div>
                        {weightError ? (
                          <span className="error">Please enter quantity</span>
                        ) : null}
                      </div>
                    </div>
                    <div className="slct-optns select-wrapper">
                      <div className="form-block-wrap">
                        <label className="enter-mobile-label">
                          Price (INR/mt)
                        </label>
                        <div className="input-wrap">
                          <input
                            className={"input-url"}
                            type="text"
                            name="product_tag"
                            placeholder="e.g. INR 25000"
                            onChange={(e) => priceHandle(e)}
                            maxLength={25}
                            id="price"
                            value={price}
                          />
                        </div>
                        {priceError ? (
                          <span className="error">Please select price</span>
                        ) : null}
                      </div>

                      <div className="form-block-wrap">
                        <label className="enter-mobile-label">
                          Product Weight
                        </label>
                        <div className="input-wrap">
                          <input
                            className={"input-url"}
                            type="text"
                            name="product_tag"
                            placeholder="e.g. 20 Kg per piece"
                            onChange={(e) => productWeightNewHandle(e)}
                            maxLength={25}
                            id="price"
                            value={productWeightNew}
                          />
                        </div>                        
                      </div>

                      {/* <div className="form-block-wrap">
                        <label className="enter-mobile-label">
                          Floor Price (INR/mt)
                        </label>
                        <div className="input-wrap">
                          <input
                            className={"input-url"}
                            type="text"
                            name="product_tag"
                            placeholder="e.g. INR 250"
                            onChange={(e) => floorPriceHandle(e)}
                            maxLength={25}
                            id="floorPrice"
                            value={floorPrice}
                          />
                        </div>
                        {floorPriceError ? (
                          <span className="error">
                            Please enter floor price
                          </span>
                        ) : null}
                      </div> */}
                    </div>
                    <div className="delivery-window">
                      <div className="enter-mobile-label">
                        Delivery Window
                        {/* <span className="highlighted">*</span> */}
                      </div>
                      <div className="date-picker-wrapper">
                        <div className="form-block-wrap">
                          <div className="input-wrap">
                            <input
                              type="date"
                              className="date-picker-input"
                              onChange={(e) => deliveryWinFirstHandle(e)}
                              id="startDate"
                              value={deliveryWinFirst}
                              pattern="\d{4}-\d{2}-\d{2}"
                            />
                            {browserName == "chrome" ? (
                              <i class="far fa-calendar-alt"></i>
                            ) : null}
                          </div>
                          {deliveryWinFirstError ? (
                            <div className="error">
                              Please select start date
                            </div>
                          ) : null}
                        </div>
                        <div className="form-block-wrap">
                          <div className="input-wrap">
                            <input
                              type="date"
                              className="date-picker-input"
                              onChange={(e) => deliveryWinSEcondHandle(e)}
                              id="endDate"
                              value={deliveryWinSecond}
                              pattern="\d{4}-\d{2}-\d{2}"
                            />
                            {browserName == "chrome" ? (
                              <i class="far fa-calendar-alt"></i>
                            ) : null}
                          </div>
                          {deliveryWinSecondError ? (
                            <div className="error">Please select end date</div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="delivery-window">
                      <div className="enter-mobile-label">
                        Valid until
                        {/* <span className="highlighted">*</span> */}
                      </div>
                      <div className="date-picker-wrapper">
                        <div className="form-block-wrap">
                          <div className="input-wrap">
                            <input
                              type="datetime-local"
                              className="date-picker-input"
                              onChange={(e) => validUntilHandle(e)}
                              id="validUntilDate"
                              value={validUntil}
                              pattern="\d{4}-\d{2}-\d{2}"
                              min={getCurrentDateTime()} // Set min to current date and time
                              max="9999-12-31T23:59"
                            />
                            {/* {browserName == "chrome" ? (
                              <i class="far fa-calendar-alt"></i>
                            ) : null} */}
                          </div>
                          {validUntilError ? (
                            <div className="error">
                              Please select valid until
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="slct-optns select-wrapper">
                      <div className="form-block-wrap">
                        <label className="enter-mobile-label">
                          Minimum Order QTY (mt){" "}
                          <span className="highlighted">*</span>
                        </label>
                        <div className="input-wrap">
                          <input
                            className={"input-url"}
                            type="text"
                            name="product_tag"
                            placeholder="e.g. 200 MT"
                            onChange={(e) => minOrderHandle(e)}
                            maxLength={25}
                            id="minOrder"
                            value={minOrderQty}
                          />
                        </div>
                        {minOrderErrror ? (
                          <span className="error">Please enter min order</span>
                        ) : null}
                        {minOrderHundredError ? (
                          <span className="error">
                            You cannot enter min order more than 100
                          </span>
                        ) : null}
                      </div>

                      <div className="form-block-wrap">
                        <label className="enter-mobile-label">
                          Product Size (mm){" "}
                        </label>
                        <div className="input-wrap">
                          <input
                            className={"input-url"}
                            type="text"
                            name="product_tag"
                            placeholder="e.g. 25-150 mm"
                            onChange={(e) => prodSizeHandle(e)}
                            maxLength={25}
                            id="productSize"
                            value={proSize}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-block-wrap">
                      <label className="enter-mobile-label">
                        Size Tolerance (±){" "}
                        <span className="highlighted">*</span>
                      </label>
                      <div className="input-wrap">
                        <input
                          className={"input-url"}
                          type="text"
                          name="product_tag"
                          placeholder="e.g. 10 %"
                          onChange={(e) => sizeTolHandle(e)}
                          maxLength={25}
                          id="sizeTolerance"
                          value={sizeTol}
                          disabled={productName === 'Pig Iron'}
                        />
                      </div>
                      {sizeTolError ? (
                        <span className="error">
                          Please enter size tolerance
                        </span>
                      ) : null}
                    </div>
                    <UploadImg
                      setSelectImgHandler={setSelectImgHandler}
                      setProdImgs={setProdImgs}
                      prodImgs={state.prodImgs}
                    />
                    {uploadImageDataError ? (
                      <span className="error">
                        Please upload atleast one image
                      </span>
                    ) : null}
                  </div>
                </div>
                {/* <div className="form-block-wrap">
                                        <label className="enter-mobile-label">Product Specification</label>
                                        <div className="input-wrap">
                                            <input
                                                className={"input-url"}
                                                type="text"
                                                name="product_tag"
                                                placeholder="e.g. 25 %"
                                                onChange={(e) => gradeHandle(e)}
                                                maxLength={25}
                                            />
                                        </div>
                                    </div> */}

                <div className="product-spec-wrapper">
                  <label className="enter-mobile-label">
                    Product Specification (%){" "}
                    <span className="highlighted">*</span>
                  </label>
                  <div className="metal-table-structure">
                    <div className="metal-table-products">
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">Si (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => siOneHandle(e)}
                              value={siOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => siTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={siTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={siTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => siTwoHandle(e)} value={siTwo} /> */}
                          </div>
                        </div>
                      </div>
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">P (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => pOneHandle(e)}
                              value={pOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => pTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={pTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={pTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => pTwoHandle(e)} value={pTwo} /> */}
                          </div>
                        </div>
                      </div>
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">Mo (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => moOneHandle(e)}
                              value={moOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => moTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={moTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={moTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => moTwoHandle(e)} value={moTwo} /> */}
                          </div>
                        </div>
                      </div>

                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">Fe (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => feOneHandle(e)}
                              value={feOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => feTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={feTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={feTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => mgTwoHandle(e)} value={mgTwo} /> */}
                          </div>
                        </div>
                      </div>
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">CaO (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => caoOneHandle(e)}
                              value={caoOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => caoTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={caoTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={caoTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => mgTwoHandle(e)} value={mgTwo} /> */}
                          </div>
                        </div>
                      </div>
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">SiO<sub>2</sub> (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => sio2OneHandle(e)}
                              value={sio2One}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => sio2TwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={sio2Two == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={sio2Two == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => mgTwoHandle(e)} value={mgTwo} /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="metal-table-products">
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">Mn (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => mnOneHandle(e)}
                              value={mnOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => mnTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={mnTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={mnTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => mnTwoHandle(e)} value={mnTwo} /> */}
                          </div>
                        </div>
                      </div>
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">S (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => sOneHandle(e)}
                              value={sOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => sTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={sTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={sTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => sTwoHandle(e)} value={sTwo} /> */}
                          </div>
                        </div>
                      </div>
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">AI (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => aiOneHandle(e)}
                              value={aiOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => aiTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={aiTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={aiTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => aiTwoHandle(e)} value={aiTwo} /> */}
                          </div>
                        </div>
                      </div>
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">Ca (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => caOneHandle(e)}
                              value={caOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => caTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={caTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={caTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => mgTwoHandle(e)} value={mgTwo} /> */}
                          </div>
                        </div>
                        
                      </div>
                      <div className="metal-table-panel" style={{borderBottom: "1px solid rgba(128, 128, 128, 0.25)"}}>
                        <div className="metal-table-line">
                          <div className="metal-heading-product">K<sub>2</sub>O (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => k2oOneHandle(e)}
                              value={k2oOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => k2oTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={k2oTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={k2oTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => mgTwoHandle(e)} value={mgTwo} /> */}
                          </div>
                        </div>

                        <div className="metal-table-line">
                          <div className="metal-heading-product">FC(%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => fcOneHandle(e)}
                              value={fcOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => fcTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={fcTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={fcTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => mgTwoHandle(e)} value={mgTwo} /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="metal-table-products">
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">C (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => cOneHandle(e)}
                              value={cOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => cTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={cTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={cTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => cTwoHandle(e)} value={cTwo} /> */}
                          </div>
                        </div>
                      </div>
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">Cr (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => crOneHandle(e)}
                              value={crOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => crTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={crTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={crTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => crTwoHandle(e)} value={crTwo} /> */}
                          </div>
                        </div>
                      </div>
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">MgO (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => mgOneHandle(e)}
                              value={mgOne}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => mgTwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={mgTwo == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={mgTwo == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => mgTwoHandle(e)} value={mgTwo} /> */}
                          </div>
                        </div>
                      </div>
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">Al<sub>2</sub>O<sub>3</sub> (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => al2o3OneHandle(e)}
                              value={al2o3One}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => al2o3TwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={al2o3Two == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={al2o3Two == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => mgTwoHandle(e)} value={mgTwo} /> */}
                          </div>
                        </div>
                      </div>
                      
                      
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product">Na<sub>2</sub>O<sub>3</sub> (%)</div>
                          <div className="metal-table-inputs">
                            <input
                              className="metal-input-table"
                              placeholder="0"
                              type="text"
                              maxLength={8}
                              onChange={(e) => na2o3OneHandle(e)}
                              value={na2o3One}
                            />
                            <select
                              className="metal-input-table select-m"
                              onChange={(e) => na2o3TwoHandle(e)}
                            >
                              <option disabled={true} selected={true}>
                                Select
                              </option>
                              <option value="N/A">N/A </option>
                              <option
                                selected={na2o3Two == "max" ? true : false}
                                value="max"
                              >
                                Max
                              </option>
                              <option
                                selected={na2o3Two == "min" ? true : false}
                                value="min"
                              >
                                Min
                              </option>
                            </select>
                            {/* <input className='metal-input-table' placeholder='0' type="text" onChange={(e) => mgTwoHandle(e)} value={mgTwo} /> */}
                          </div>
                        </div>
                      </div>
                      
                      <div className="metal-table-panel">
                        <div className="metal-table-line">
                          <div className="metal-heading-product"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {productSpecificationError ? (
                    <span className="error">
                      Please enter atleast one specification
                    </span>
                  ) : null}
                </div>

                <div className="form-block-wrap">
                  <label className="enter-mobile-label">
                    Specification Tolerance (±){" "}
                    <span className="highlighted">*</span>
                  </label>
                  <div className="input-wrap">
                    <input
                      className={"input-url"}
                      type="text"
                      name="product_tag"
                      placeholder="e.g. 0.5 %"
                      onChange={(e) => specTolHandle(e)}
                      maxLength={25}
                      id="specTol"
                      value={specificationTol}
                      disabled={productName === 'Pig Iron'}
                    />
                  </div>
                  {specificationTolError ? (
                    <span className="error">
                      Please enter specification tolerance
                    </span>
                  ) : null}
                </div>

                <div className="form-block-wrap">
                  <label className="enter-mobile-label">
                    Moisture {" "}
                  </label>
                  <div className="input-wrap">
                    <input
                      className={"input-url"}
                      type="text"
                      name="product_tag"
                      placeholder="e.g. 5 %"
                      onChange={(e) => moistureHandle(e)}
                      maxLength={25}
                      id="specTol"
                      value={moisture}
                      disabled={productName === 'Pig Iron'}
                    />
                  </div>
                </div>

                <div className="delivery-wrapper add-product-delivery">
                  <div className="enter-mobile-label">
                    Delivery<span className="highlighted">*</span>
                  </div>
                  <div className="slct-optns select-wrapper delivery-wrapper-form">
                    <div className="form-block-wrap">
                      <div className="select-main-wrapper">
                        <select
                          onChange={(e) => deliveryFirstHandler(e)}
                          id="deliveryType"
                        >
                          <option value={""}>Select</option>
                          {deliveryFirst.map((item) => (
                            <option
                              value={item._id}
                              selected={
                                deliveryFirstValue == item.name ? true : false
                              }
                            >
                              {item.name}
                            </option>
                          ))}
                        </select>
                        <i className="icon-arrow-down"></i>
                      </div>
                      {deliveryFirstValueError ? (
                        <span className="error">
                          Please select delivery type
                        </span>
                      ) : null}
                    </div>
                    {/* <div className='form-block-wrap'>
                                                <div className='select-main-wrapper'>
                                                    <select onChange={(e) => deliverySecondHandler(e)} id="state">
                                                        <option value={""}>Select City</option>
                                                        {
                                                            stateDataArr && stateDataArr.stateData && stateDataArr.stateData.map(item => <option value={item.name} selected={state == item._id ? true : false}>{item.name}</option>)
                                                        }
                                                    </select>
                                                    <i className='icon-arrow-down'></i>
                                                </div>
                                                {deliverySecondValueError ? <span className='error'>Please select state</span> : null}
                                            </div> */}
                    <div className="input-form-wrap select-affilation-profile form-block-wrap">
                      <div className="form-intput select-affilation-wrap complete-profile-select">
                        <div className="select-main-wrapper">
                          <Multiselect
                            id="state"
                            options={optionsSelect} // Options to display in the dropdown
                            selectedValues={selectedValue} // Preselected value to persist in dropdown
                            onSelect={(e) => onSelect(e)} // Function will trigger on select event
                            onRemove={(e) => onRemove(e)} // Function will trigger on remove event
                            displayValue="name" // Property name to display in the dropdown options
                          />
                          <i className="icon-arrow-down"></i>
                        </div>
                        {deliverySecondValueError ? (
                          <span className="error">Please select Region</span>
                        ) : null}
                      </div>
                    </div>
                    <div className="input-form-wrap select-affilation-profile form-block-wrap">
                      <div className="form-intput select-affilation-wrap complete-profile-select">
                        <div className="select-main-wrapper">
                          {/* <Multiselect
                                                            id="setCity"
                                                            options={optionsSelectRegionRegion} // Options to display in the dropdown
                                                            selectedValues={selectedValueRegion} // Preselected value to persist in dropdown
                                                            onSelect={(e) => onSelectRegion(e)} // Function will trigger on select event
                                                            onRemove={(e) => onRemoveRegion(e)} // Function will trigger on remove event
                                                            displayValue="name" // Property name to display in the dropdown options
                                                        />
                                                        <i className='icon-arrow-down'></i> */}
                          <div className="select-main-wrapper">
                            <select
                              onChange={(e) => onSelectRegion(e)}
                              id="setCity"
                            >
                              <option value={""}>Select</option>
                              {optionsSelectRegionRegion.map((item) => (
                                <option
                                  value={item.id}
                                  selected={
                                    selectedValueRegion[0] &&
                                    selectedValueRegion[0].id == item.id
                                      ? true
                                      : false
                                  }
                                >
                                  {item.name}
                                </option>
                              ))}
                            </select>
                            <i className="icon-arrow-down"></i>
                          </div>
                        </div>
                        {cityValueError ? (
                          <span className="error">Please select city</span>
                        ) : null}
                      </div>
                    </div>
                    {/* <div className='form-block-wrap input-form-block'>
                                                <div className='select-main-wrapper'>
                                                    <div className="input-wrap">
                                                        <input type="text" className='date-picker-input' placeholder='Enter City' onChange={(e) => deliveryWinThirdHandle(e)} value={city} />
                                                    </div>
                                                </div>
                                            </div> */}
                  </div>
                </div>

                <div className="select-pckage-wrap">
                  <div className="form-block-wrap">
                    <div className="enter-mobile-label">
                      Payment Type<span className="highlighted">*</span>
                    </div>
                    <div className="select-main-wrapper">
                      <select
                        onChange={(e) => paymentTypeHandler(e)}
                        id="paymentType"
                      >
                        <option value={""}>Select</option>
                        {paymentTypeList.map((item) => (
                          <option
                            value={item._id}
                            selected={paymentType == item.name ? true : false}
                          >
                            {item.name}
                          </option>
                        ))}
                      </select>
                      <i className="icon-arrow-down"></i>
                    </div>
                    {paymentTypeError ? (
                      <span className="error">Please select payment type</span>
                    ) : null}

                    {paymentType == "Other" ? (
                      <div className="form-block-wrap payment-other-type">
                        <div className="input-wrap">
                          <input
                            type="text"
                            placeholder="Enter payment type"
                            onChange={(e) => otherPayTypeHandle(e)}
                            id="otherPayment"
                            value={otherPayType}
                          />
                        </div>
                        {otherPayTypeError ? (
                          <span className="error">
                            Please enter payment type
                          </span>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                  <div className="form-block-wrap new-select-wrapper">
                    <div className="enter-mobile-label">
                      Packaging<span className="highlighted">*</span>
                    </div>
                    <div className="select-main-wrapper">
                      {/* <select onCha nge={(e)=>handlePackaging(e)}>
                                                   <option value="">Select</option>
                                                   <option value="40 kg Jute"  selected={packaging == "40 kg Jute" ? true : false}>40 kg Jute</option>
                                                   <option value="50 kg jute"  selected={packaging == "50 kg jute" ? true : false}>50 kg jute</option>
                                                   <option value="1 MT Jumbo"  selected={packaging == "1 MT Jumbo" ? true : false}>1 MT Jumbo</option>
                                               </select> */}
                      <div className="check-product-wrap">
                        <div className="new-check-wrp">
                          <input
                            type="checkbox"
                            id="vehicle1"
                            name="vehicle1"
                            value="40 kg bag"
                            onChange={(e) => handleJute(e)}
                            checked={packaging.find((item) =>
                              item == "40 kg bag" ? true : false
                            )}
                          />
                          <label for="vehicle1">40 kg bag</label>
                        </div>
                        <div className="new-check-wrp">
                          <input
                            type="checkbox"
                            id="vehicle2"
                            name="vehicle2"
                            value="50 kg bag"
                            onChange={(e) => handleJute50(e)}
                            checked={packaging.find((item) =>
                              item == "50 kg bag" ? true : false
                            )}
                          />
                          <label for="vehicle2">50 kg bag</label>
                        </div>
                      </div>
                      <div className="check-product-wrap">
                        <div className="new-check-wrp">
                          <input
                            type="checkbox"
                            id="vehicle3"
                            name="vehicle3"
                            value="1 MT Jumbo bag"
                            onChange={(e) => handleJumbo(e)}
                            checked={packaging.find((item) =>
                              item == "1 MT Jumbo bag" ? true : false
                            )}
                          />
                          <label for="vehicle3">1 MT Jumbo bag</label>
                        </div>
                        <div className="new-check-wrp">
                          <input
                            type="checkbox"
                            id="vehicle4"
                            name="vehicle4"
                            value="Loose"
                            onChange={(e) => handleJumbo(e)}
                            checked={packaging.find((item) =>
                              item == "Loose" ? true : false
                            )}
                          />
                          <label for="vehicle4">Loose</label>
                        </div>
                      </div>

                      <div className="check-product-wrap">
                        <div className="new-check-wrp">
                          <input
                            type="checkbox"
                            id="vehicle3"
                            name="vehicle3"
                            value="Bag Packing"
                            onChange={(e) => handleJumbo(e)}
                            checked={packaging.find((item) =>
                              item == "Bag Packing" ? true : false
                            )}
                          />
                          <label for="vehicle3">Bag Packing</label>
                        </div>
                      </div>
                    </div>
                    {packagingError ? (
                      <span className="error">
                        Please select Packaging type
                      </span>
                    ) : null}
                  </div>
                </div>

                <div className="slct-optns select-wrapper">
                  <div className="form-block-wrap">
                    <label className="enter-mobile-label">
                      Loading Charges (INR/mt) (Included in price)
                      {/* <span className="highlighted">*</span> */}
                    </label>
                    <div className="input-wrap">
                      <input
                        className={"input-url"}
                        type="text"
                        name="product_tag"
                        placeholder="e.g. INR 20"
                        onChange={(e) => loadingChangesHandle(e)}
                        maxLength={25}
                        id="loadingCharges"
                        value={loadingChanges}
                      />
                    </div>
                    {loadingChangesError ? (
                      <span className="error">
                        Please enter loading Charges
                      </span>
                    ) : null}
                  </div>

                  <div className="form-block-wrap">
                    <label className="enter-mobile-label">
                      Insurance Charges (INR/mt) (Included in price)
                      {/* <span className="highlighted">*</span> */}
                    </label>
                    <div className="input-wrap">
                      <input
                        className={"input-url"}
                        type="text"
                        name="product_tag"
                        placeholder="e.g. INR 20"
                        onChange={(e) => insuranceChargesHandle(e)}
                        maxLength={25}
                        id="insuranceCharges"
                        value={insuranceCharges}
                      />
                    </div>
                    {insuranceChargesError ? (
                      <span className="error">
                        Please enter insurance charges
                      </span>
                    ) : null}
                  </div>
                </div>

                <div className="form-block-wrap">
                  <label className="enter-mobile-label">
                    Remarks
                    {/* <span className="highlighted">*</span> */}
                  </label>
                  <div className="input-wrap">
                    <input
                      className={"input-url"}
                      type="text"
                      name="remarks"
                      onChange={(e) => setRemarks(e.target.value)}
                      maxLength={300}
                      id="insuranceCharges"
                      value={remarks}
                    />
                  </div>
                  {insuranceChargesError ? (
                    <span className="error">
                      Please enter insurance charges
                    </span>
                  ) : null}
                </div>

                <div className="attr">
                  <div className="navigation-container both-btn">
                    {!params.id ? (
                      <div className="navigation-back">
                        <button className="next-btn">Upload Product</button>
                      </div>
                    ) : (
                      <div>
                        <button
                          // onClick={props.submitFun}
                          className="next-btn"
                        >
                          Update Product
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        ) : (
          !isEmpty(userProfile) && (
            <div>
              <AccVerifiedPopup
                verification={
                  userProfile.userdata && userProfile.userdata.verified
                }
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default AddProduct;
